var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrackingParcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "currentColor",
    viewBox: "0 0 80 80",
    stroke: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.554 78.533c19.084 0 34.554-8.523 34.554-19.038 0-10.514-15.47-19.038-34.554-19.038C20.471 40.457 5 48.981 5 59.495 5 70.01 20.47 78.533 39.554 78.533Z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.3 41.959-3.656-2.512-5.403 7.88 3.657 2.512 5.403-7.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "m17.292 58.389 8.38-12.231 6.888 4.731-8.38 12.231a4.17 4.17 0 0 1-5.803 1.076 4.172 4.172 0 0 1-1.085-5.807ZM45.949 43.776c11.815 0 21.393-9.586 21.393-21.412C67.342 10.54 57.764.952 45.949.952c-11.815 0-21.393 9.587-21.393 21.412 0 11.826 9.578 21.412 21.393 21.412Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m37.604 42.743-3.656-2.512-5.403 7.88 3.657 2.511 5.402-7.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    d: "m18.597 59.172 8.38-12.23 6.887 4.731-8.38 12.23a4.17 4.17 0 0 1-5.802 1.077 4.172 4.172 0 0 1-1.085-5.808ZM47.253 44.56c11.815 0 21.393-9.587 21.393-21.412 0-11.826-9.578-21.412-21.393-21.412-11.816 0-21.394 9.586-21.394 21.412 0 11.825 9.578 21.412 21.394 21.412Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M47.315 39.86c9.222 0 16.697-7.483 16.697-16.712 0-9.23-7.475-16.712-16.697-16.712-9.221 0-16.697 7.482-16.697 16.712S38.094 39.86 47.315 39.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.2,
    stroke: "#fff",
    d: "M53.9 18.458a.16.16 0 0 0 0-.271L48.088 14.7a2.382 2.382 0 0 0-2.449 0l-5.812 3.486a.16.16 0 0 0 0 .271l6.96 4.226a.15.15 0 0 0 .155 0l6.96-4.226ZM39.175 19.527a.148.148 0 0 0-.153 0 .157.157 0 0 0-.076.137v6.831c.001.33.085.652.244.938.16.285.388.522.664.688l6.172 3.82a.147.147 0 0 0 .152 0 .156.156 0 0 0 .077-.136v-7.926a.16.16 0 0 0-.077-.136l-7.003-4.216ZM47.473 23.907v7.895a.16.16 0 0 0 .076.137.15.15 0 0 0 .152 0l6.172-3.82c.276-.166.504-.402.663-.687.16-.285.244-.608.245-.937v-6.83a.16.16 0 0 0-.076-.136.149.149 0 0 0-.152 0l-7.004 4.242a.155.155 0 0 0-.076.136Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrackingParcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tracking-parcel.140f98b94068db012fd2431a2788f1e5.svg";